import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider, ToastProvider } from "@promptgatewaysadmin/ui";
import "@promptgatewaysadmin/ui/styles.css";
import "./styles/portal.css";

import { AuthProvider } from "./auth/AuthProvider.js";
import { PortalClientProvider } from "./api/PortalClientProvider.js";
import { SessionProvider } from "./auth/SessionProvider.js";
import { createQueryClient } from "./queries/client.js";
import { AppRouter } from "./router/index.js";

/**
 * The provider tree. Order matters and is fixed:
 *
 *   ThemeProvider          reads the pre-paint seed; owns data-theme on <html>
 *   AuthProvider           GCIP session + getToken
 *   QueryClientProvider    the cache, the retry policy, refetchOnWindowFocus
 *   PortalClientProvider   one egress base — the Edge; also the test DI seam
 *   ToastProvider          a polite live region, never the only channel for an error
 *   SessionProvider        blocks on GET /v1/identity/me; supplies org + role
 *
 * ToastProvider sits ABOVE SessionProvider because the guards fire toasts, and a guard can
 * render while the session is still resolving.
 */
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <QueryClientProvider client={createQueryClient()}>
          <PortalClientProvider>
            <ToastProvider>
              <SessionProvider>
                <AppRouter />
              </SessionProvider>
            </ToastProvider>
          </PortalClientProvider>
        </QueryClientProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>,
);
